var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-spin",
    { attrs: { size: "large", spinning: _vm.loading } },
    [
      _c("div", { staticClass: "home" }, [
        _c(
          "div",
          { staticClass: "wrap-step" },
          [
            _c("Step", {
              attrs: {
                current: _vm.$route.query.isfromCamp == 1 ? 3 : 2,
                isfromCamp: _vm.$route.query.isfromCamp == 1 ? true : false,
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "wrap-pay" }, [
          _c(
            "div",
            { staticClass: "binfo" },
            [
              _c("span", { class: [_vm.lang] }, [
                _vm._v(_vm._s(_vm.$t("EnterPaymentDetails"))),
              ]),
              _vm.havAccount == 2
                ? _c(
                    "a-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.havAccount = 1
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Cancel")))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-box", staticStyle: { "padding-top": "30px" } },
            [
              _c(
                "a-form",
                {
                  staticClass: "form",
                  attrs: { form: _vm.form, formLayout: "vertical" },
                },
                [
                  [
                    _c("div", { attrs: { id: "card-container" } }),
                    _vm.errorInfo
                      ? _c(
                          "div",
                          {
                            staticClass: "error",
                            staticStyle: {
                              color: "#ff4e3a",
                              "padding-top": "16px",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.errorInfo) + " ")]
                        )
                      : _vm._e(),
                  ],
                ],
                2
              ),
            ],
            1
          ),
          _c("div", { staticClass: "tit" }, [_vm._v(_vm._s(_vm.$t("Order")))]),
          _vm.$route.query.discount_code
            ? _c("ul", [
                _c("li", [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("OriginalPrice"))),
                  ]),
                  _c("div", { staticClass: "cont" }, [
                    _vm._v(
                      " $" +
                        _vm._s(
                          parseFloat(_vm.$route.query.original_price).toFixed(2)
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _c("li", [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("Discount"))),
                  ]),
                  _c("div", { staticClass: "cont" }, [
                    _vm._v(
                      " - $" +
                        _vm._s(
                          parseFloat(_vm.$route.query.discount_price).toFixed(2)
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _c("li", [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("TotalPrice"))),
                  ]),
                  _c("div", { staticClass: "cont money" }, [
                    _vm._v(
                      " $" +
                        _vm._s(parseFloat(_vm.$route.query.price).toFixed(2)) +
                        " "
                    ),
                  ]),
                ]),
              ])
            : _c("ul", [
                _c("li", [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.$t("OriginalPrice"))),
                  ]),
                  _c("div", { staticClass: "cont" }, [
                    _vm._v(
                      " $" +
                        _vm._s(
                          parseFloat(_vm.$route.query.original_price).toFixed(2)
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _c("li", [
                  _c("div", { staticClass: "label", class: [_vm.lang] }, [
                    _vm._v(_vm._s(_vm.$t("TotalPrice"))),
                  ]),
                  _c("div", { staticClass: "cont money" }, [
                    _vm._v(
                      " $" +
                        _vm._s(parseFloat(_vm.$route.query.price).toFixed(2)) +
                        " "
                    ),
                  ]),
                ]),
              ]),
          _vm.$route.query.type == 4
            ? _c("div", { staticClass: "Aftertrialends" }, [
                _vm._v(" " + _vm._s(_vm.$t("Aftertrialends")) + " "),
              ])
            : _vm._e(),
          _c("div", { staticClass: "baozhang" }, [
            _c(
              "p",
              { staticClass: "t1" },
              [
                _c("a-icon", {
                  staticClass: "icon",
                  attrs: { type: "safety-certificate" },
                }),
                _vm._v(" " + _vm._s(_vm.$t("fourMoth"))),
                _c(
                  "a-tooltip",
                  {
                    attrs: {
                      placement: "bottom",
                      overlayClassName: "customTip",
                    },
                  },
                  [
                    _c("template", { slot: "title" }, [
                      _c("p", { staticStyle: { "font-size": "12px" } }, [
                        _vm._v(" " + _vm._s(_vm.$t("Termsandconditionsapply"))),
                        _c("br"),
                        _vm._v(
                          " • " + _vm._s(_vm.$t("Aleast10campaigns")) + " "
                        ),
                        _c("br"),
                        _vm._v(
                          " • " + _vm._s(_vm.$t("Atleasttwocampaigns")) + " "
                        ),
                        _c("br"),
                        _vm._v(
                          " • " + _vm._s(_vm.$t("Noleadsweregenerated")) + " "
                        ),
                        _c("br"),
                        _vm._v(
                          " • " + _vm._s(_vm.$t("Thispolicyapplies")) + " "
                        ),
                      ]),
                    ]),
                    _c(
                      "span",
                      [
                        _c("a-icon", {
                          staticStyle: { color: "#fff", "margin-left": "5px" },
                          attrs: { type: "exclamation-circle" },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
            _c("p", {
              staticClass: "t2",
              domProps: { innerHTML: _vm._s(_vm.formatEmail2()) },
            }),
          ]),
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "a-button",
                {
                  staticClass: "btn",
                  attrs: { size: "large" },
                  on: { click: _vm.back },
                },
                [_vm._v(_vm._s(_vm.$t("Back")))]
              ),
              _c(
                "a-button",
                {
                  staticClass: "btn",
                  attrs: { size: "large", id: "confirm", type: "primary" },
                  on: { click: _vm.triggerConfirm },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$route.query.type == 4
                        ? _vm.$t("Bindcard")
                        : _vm.$t("Purchase")
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("LeaveupDialog", {
        ref: "leaveDialog",
        on: { callback: _vm.callback, goPay: _vm.triggerConfirm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }